/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- COMMENTING : PREVIEW CONFIG : STYLES --------------- ++++++++++ */
export default theme => ({
  previewconfig: {
    background: '#ffffff',
    minWidth: pxToEm(300),
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '&.disabled-true': {
      opacity: 0.4,
      pointerEvents: 'none'
    },
    '& .header': {
      display: 'flex',
      background: '#e7eaf7',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: pxToEm(48),
      borderTopLeftRadius: pxToEm(12),
      borderTopRightRadius: pxToEm(12)
    },
    '& .content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: pxToEm(100),
      height: '100%',
      width: '100%',
      padding: pxToEm(16),
      gap: pxToEm(8),
      borderBottomLeftRadius: pxToEm(12),
      borderBottomRightRadius: pxToEm(12),
      border: `1px solid #e7eaf7`
    }
  }
});
